export default class PasswordFormControl extends HTMLDivElement {
    connectedCallback() {
        const password = this.querySelector('input');
        const togglePassword = this.querySelector('svg');
        const icon = this.querySelector('svg use');

        togglePassword.addEventListener('click', () => {
            // Toggle the type attribute using
            // getAttribure() method
            const type = password
                .getAttribute('type') === 'password' ?
                'text' : 'password';
            password.setAttribute('type', type);
            // Toggle the eye and bi-eye icon
            
            if (icon.getAttribute('xlink:href') === '/bundles/icons/sprites.svg#icon-eye') {
                icon.setAttribute('xlink:href', '/bundles/icons/sprites.svg#icon-eye-off');
            }
            else {
                icon.setAttribute('xlink:href', '/bundles/icons/sprites.svg#icon-eye');
            }
        });

        password.addEventListener('keyup', () => {
            if (password.value.length > 0) {
                togglePassword.style.display = 'block';
                password.classList.add('show-eye');
            }
            else {
                togglePassword.style.display = 'none';
                password.classList.remove('show-eye');
            }
        });
    }
}

customElements.define("password-formcontrol", PasswordFormControl, { extends: "div" });